export default __webpack_public_path__ + "static/media/YAS0720.34I-34466_-18903_0.379e84de.jpg";